import * as React from 'react';

import Form from '../FormGenerator/Form';
import { MutationFunc } from 'react-apollo';
import { requestCompanyChange } from '../../formFields';
import { Button, Modal } from '../../modules/modules';
import FlashStore from '../../services/FlashStore';

interface IRequestCompanyChangeState {
    requestChangeValues: any;
    requestFormSentSuccessfully: boolean;
}

interface IRequestCompanyChangeProps {
    customer: any;
    requestCompanyChange: MutationFunc;
    toggleRequestForm: () => void;
}

class RequestCompanyChangeModal extends React.Component<IRequestCompanyChangeProps, IRequestCompanyChangeState> {
    constructor(props: IRequestCompanyChangeProps) {
        super(props);

        this.state = {
            requestFormSentSuccessfully: false,
            requestChangeValues: {
                ...props.customer,
                RequestAddressStreet: props.customer.AddressStreet,
                RequestAddressStreetNumber: props.customer.AddressStreetNumber,
                RequestAddressLine1: props.customer.AddressLine1,
                RequestAddressLine2: props.customer.AddressLine2,
                RequestAddressZip: props.customer.AddressZip,
                RequestAddressCity: props.customer.AddressCity,
                RequestAddressCountyState: props.customer.AddressCountyState,
                RequestAddressCountry: props.customer.AddressCountry,
            }
        };

        this.handleRequestChangeSend = this.handleRequestChangeSend.bind(this);
        this.handleRequestChange = this.handleRequestChange.bind(this);
    }

    public handleRequestChange(value: any, field: string) {
        this.setState({ requestChangeValues: { ...this.state.requestChangeValues, [field]: value } });
    }

    public async handleRequestChangeSend(form: any) {
        const {
            AddressStreet,
            AddressStreetNumber,
            AddressLine1,
            AddressLine2,
            AddressZip,
            AddressCity,
            AddressCountyState,
            AddressCountry,

            Company,
            CompanyRegistrationNumber,
            CompanyVatNumber,
            Message
        } = this.state.requestChangeValues;

        const {
            Firstname,
            Lastname,
            Email
        } = this.props.customer;

        try {
            const user = {
                invoiceFirstName: Firstname,
                invoiceLastName: Lastname,
                email: Email,
                invoiceStreet: AddressStreet,
                invoiceHouseNumber: AddressStreetNumber,
                invoiceAddressLine1: AddressLine1,
                invoiceAddressLine2: AddressLine2 || null,
                invoiceZip: AddressZip,
                invoiceCity: AddressCity,
                invoiceCountyState: AddressCountyState || null,
                invoiceCountry: AddressCountry,
                companyName: Company,
                companyRegistrationNumber: CompanyRegistrationNumber,
                companyVatNumber: CompanyVatNumber,
                message: Message,
            };

            await this.props.requestCompanyChange({
                variables: {
                    user
                }
            });

            this.setState({ requestFormSentSuccessfully: true });
            FlashStore.GetInstance().showMessage('Personal data successfully updated', 'success');

        } catch (e) {
            FlashStore.GetInstance().showMessage('Unexpected error happened. Try it again or contact us by e-mail', 'error');
        }
    }

    public render() {
        const { toggleRequestForm } = this.props;
        const { requestChangeValues, requestFormSentSuccessfully } = this.state;
        return (
            <Modal type={'general'} open={true} onClose={toggleRequestForm}>
                <div className="modal__head">
                    <div className="modal__title">
                        Request company details change
                    </div>
                    <button className="modal__close" onClick={toggleRequestForm} />
                </div>
                <div className="modal__body" style={{ textAlign: 'left', padding: 20 }}>
                    {requestFormSentSuccessfully
                        ? <div>
                            <p>
                                Your request to change company details has been successfully sent to our support team.
                            </p>
                            <p>
                                Our colleagues will review the request as soon as possible and may contact you
                                if additional information or verification documents are required.
                            </p>
                            <p>
                                Thank you for your understanding.

                            </p>
                        </div>
                        : <Form
                            fields={[...requestCompanyChange] as Array<any>}
                            values={requestChangeValues}
                            handleChange={this.handleRequestChange}
                        >
                            {(form: any) => {
                                return (
                                    <Button
                                        type="text"
                                        onClick={() => {
                                            this.handleRequestChangeSend(form);
                                        }}
                                    >
                                        Request change
                                    </Button>
                                );
                            }}
                        </Form>}
                </div>
            </Modal>
        );
    }
}

export default RequestCompanyChangeModal;



// WEBPACK FOOTER //
// ./src/components/CustomerData/RequestChangeModal.tsx